module.exports = __webpack_public_path__ + "img/S08.05380350.png";